import { LINK } from '@/links';

export default {
  name: 'ModalWithoutApplicationComponent',
  props: ['show', 'close'],
  methods: {
    changeToCuprum() {
      window.location.href = LINK.CHANGE_TO_CUPRUM;
    },
  },
};
